import { setReloadLedaga } from "actions";
import { setReloadPanhematin } from "actions";
import { setReloadSylvant } from "actions";

import {
    SET_CONSENT_PATH,
    SET_CONSENT_URL,
    LOAD_INFO_IMPACT,
    SET_IMPACT_START_DATE,
    SET_CLINICAL_HISTORY_STATE,
    SET_FORM_FORMULA_DONE,
    SET_FORMULA_MEDICINE_QUANTITY,
    ON_START_IMPACT,
    CALL_RELOAD_ALERTS,
    CALL_RELOAD_PATIENT_DATA,
    CALL_RELOAD_CONSUMPTION_TRACING,
    SET_HISTORY_DATA, /* ================ */
    SET_HEALTH_DATA,
    SET_RELOAD_DOSAGE,
    SET_RELOAD_LEDAGA,
    SET_RELOAD_PANHEMATIN,
    SET_RELOAD_SYLVANT,
    SET_RELOAD_VITAL_NOT_AVAILABLE,
  } from "constants/ActionTypes";
  
const INIT_STATE = {
    consentPath: null,
    consentSigned: false,
    patientFullName: null,
    referralConsentFile: null,
    impactStartDate: null,
    impactEndDate: null,
    expeditionDateFormula: null,
    clinicalHistoryStateDone: false,
    startImpact:false,
    //file clinic history variableGroupId
    fileCHVariableGroupId: 0,
    reloadAlerts:false,
    reloadPatientData:false,
    reloadConsumptionTracing:false,
    isCIRequired: false,
    ciDisplayable: null,
    historyData : false,  /* ================ */
    audioUrl: null,
    medicineQuantity: null,
    healthData: null,
    reloadDosageInfo: false,
  };
 
export default (state = INIT_STATE, {type, payload}) => {
    switch (type) {
        case SET_CONSENT_PATH: {
            const consentSigned = payload || state.audioUrl ? true : false;
            return { ...state, 
                consentPath: payload,
                audioUrl: null,
                consentSigned: consentSigned
            };
        }
        case SET_CONSENT_URL: {
            const consentSigned = payload || state.consentPath ? true : false;
            return { ...state, 
                audioUrl: payload,
                consentPath: null,
                consentSigned: consentSigned
            };
        }
        case LOAD_INFO_IMPACT: {
            const consentSigned = payload.audioUrl || payload.consentPath ? true : false;
            return { ...state, ...payload, consentSigned: consentSigned };
        }
        case SET_IMPACT_START_DATE: {
            return { ...state, 
                impactStartDate: payload,
            };
        }
        case SET_CLINICAL_HISTORY_STATE: {
            return { ...state, clinicalHistoryStateDone: payload};
        }
        case SET_HISTORY_DATA: {  /* ================ */
            return { ...state, historyData: payload};
        }
        case SET_FORM_FORMULA_DONE: {
            return { ...state, expeditionDateFormula: payload};
        }
        case SET_FORMULA_MEDICINE_QUANTITY: {
            return { ...state, medicineQuantity: payload};
        }
        case ON_START_IMPACT: {
            return { ...state, startImpact: payload};
        }
        case CALL_RELOAD_ALERTS: {
            return { ...state, reloadAlerts: payload};
        }
        case CALL_RELOAD_PATIENT_DATA: {
            return { ...state, reloadPatientData: payload};
        }
        case CALL_RELOAD_CONSUMPTION_TRACING: {
            return { ...state, reloadConsumptionTracing: payload};
        }
        case SET_HEALTH_DATA: {
            return { ...state, healthData: payload};
        }
        case SET_RELOAD_DOSAGE: {
            return { ...state, reloadDosageInfo: payload};
        }
        case SET_RELOAD_LEDAGA: {
            return { ...state, setReloadLedagaInfo: payload};
        }
        case SET_RELOAD_PANHEMATIN: {
            return { ...state, setReloadPanhematinInfo: payload};
        }
        case SET_RELOAD_SYLVANT: {
            return { ...state, setReloadSylvantInfo: payload};
        }
        case SET_RELOAD_VITAL_NOT_AVAILABLE: {
            return { ...state, setReloadVitalNotAvailableInfo: payload};
        }
        default:
        return state;
    }
};
  